import React, { useState } from 'react';
import { Icon } from '@lnr-v2/ui';
import { AdminLayout } from '../../layouts/AdminLayout';
import styles from './SettingsPage.module.css';

type TabType = 'general' | 'security';

export const SettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('general');

  const tabs = [
    {
      id: 'general' as TabType,
      label: 'General',
      icon: 'settings',
      description: 'General application settings',
    },
    {
      id: 'security' as TabType,
      label: 'Security',
      icon: 'shield',
      description: 'Security and authentication settings',
    },
  ];

  return (
    <AdminLayout>
      <div className={styles.container}>
        {/* Page header */}
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h1 className={styles.title}>Settings</h1>
            <p className={styles.subtitle}>
              Configure your application preferences
            </p>
          </div>
        </div>

        {/* Tabs navigation */}
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`${styles.tab} ${
                activeTab === tab.id ? styles.tabActive : ''
              }`}
            >
              <Icon name={tab.icon} size="sm" color="currentColor" />
              <div className={styles.tabContent}>
                <span className={styles.tabLabel}>{tab.label}</span>
                <span className={styles.tabDescription}>{tab.description}</span>
              </div>
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div className={styles.tabPanel}>
          {activeTab === 'general' && (
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>General Settings</h2>
                <p className={styles.sectionDescription}>
                  Configure general application settings.
                </p>
              </div>
              <div className={styles.placeholder}>
                <Icon name="settings" size="lg" color="currentColor" />
                <p>General settings coming soon...</p>
              </div>
            </div>
          )}

          {activeTab === 'security' && (
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Security Settings</h2>
                <p className={styles.sectionDescription}>
                  Manage security and authentication preferences.
                </p>
              </div>
              <div className={styles.placeholder}>
                <Icon name="shield" size="lg" color="currentColor" />
                <p>Security settings coming soon...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};
